import { Sparkles, Regex, Wand2, ShieldCheck } from "lucide-react";
import SEOHead from "@/components/SEOHead";
import RegexGenerator from "@/components/RegexGenerator";
import ToolPageShell from "@/components/tools/ToolPageShell";

const faqs = [
  { q: "What regex flavor does it use?", a: "JavaScript-style regex by default — works in Node, browsers, TypeScript and most modern languages with minor tweaks." },
  { q: "How do I test the regex?", a: "Pair this with our free Regex Tester to validate against your real strings. Both tools live under /tools." },
  { q: "Can it handle complex patterns?", a: "Yes — emails, dates, URLs, IPs, log lines and more. Be specific in your description for the best results." },
  { q: "Is my prompt stored?", a: "No. We send the description to the AI model and return the regex. Nothing is logged on our servers." },
];

const RegexGeneratorPage = () => (
  <>
    <SEOHead
      title="Free Regex Generator — Plain English to Regular Expression"
      description="Describe what you want to match in plain English and get a working regex with explanation and examples. Free, AI-powered, no sign-up."
      path="/tools/regex-generator"
      keywords="regex generator, regex from text, plain english regex, AI regex builder, regular expression generator, free regex tool"
      breadcrumbs={[
        { name: "Home", path: "/" },
        { name: "Free Tools", path: "/tools" },
        { name: "Regex Generator", path: "/tools/regex-generator" },
      ]}
      jsonLd={[
        { "@context": "https://schema.org", "@type": "WebApplication", name: "NETIUS Regex Generator", url: "https://netius.com/tools/regex-generator", applicationCategory: "DeveloperApplication", operatingSystem: "Any (Web)", offers: { "@type": "Offer", price: "0", priceCurrency: "USD" } },
        { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })) },
      ]}
    />
    <ToolPageShell
      title="Regex Generator"
      subtitle="Describe the pattern in plain English. Get a working regular expression, a clear explanation, and matching/non-matching examples."
      badges={[
        { icon: Sparkles, label: "AI-powered" },
        { icon: Regex, label: "JavaScript flavor" },
        { icon: ShieldCheck, label: "Nothing stored" },
      ]}
      featuresHeading="What it does"
      features={[
        { icon: Wand2, title: "Plain-English in", description: "Skip the cryptic syntax — describe what you want to match." },
        { icon: Regex, title: "Working regex out", description: "Get the pattern and the recommended flags, ready to drop into your code." },
        { icon: Sparkles, title: "Examples included", description: "Each result lists strings that match and ones that don't, so you can sanity-check it." },
      ]}
      faqSubheading="Quick answers about the regex generator."
      faqs={faqs}
      softCtaText="Need help wiring complex parsing into a real product?"
    >
      <RegexGenerator />
    </ToolPageShell>
  </>
);

export default RegexGeneratorPage;